import e from"react";import{Section as r}from"../styles.js";const t=t=>{let{children:s,className:m}=t;return e.createElement(r,{className:m},s)};export{t as ModalBody};
//# sourceMappingURL=ModalBody.js.map
